<template>
  <v-container fluid>
    <!------------------------------------------ 表格数据搜索条件以及功能按键 ----------------------------------------->
    <v-row justify="center"
           class="mb-2"
           no-gutters>
      <v-col cols="11">
        <v-form ref="queryForm">
          <v-row justify="center">
            <v-col cols="2" xs="2" class="pb-0 pr-0">
              <z-source-selector v-if="!wmsMngFlag"
                                 clearable v-model="queryRequest.aimsWarehouseId"
                                 prepend-inner-icon="search"
                                 label="目标仓库"
                                 single-line
                                 multiple
                                 hide-details="auto"
                                 source="WarehouseSelector"/>
              <z-source-selector v-else
                                 clearable v-model="queryRequest.aimsWarehouseId"
                                 prepend-inner-icon="search"
                                 label="目标仓库"
                                 multiple
                                 single-line
                                 hide-details="auto"
                                 source="WareHouseWmsManagerSelector"/>
            </v-col>
            <v-col cols="2" xs="2" class="pb-0 pr-0">
              <v-text-field
                  clearable v-model="queryRequest.storageNo"
                  prepend-inner-icon="search"
                  label="入库单号"
                  single-line
                  @keydown.enter="queryPageReset"
                  hide-details="auto"/>
            </v-col>
            <v-col cols="2" xs="2" class="pb-0 pr-0">
              <z-source-selector
                  clearable v-model="queryRequest.storageType"
                  prepend-inner-icon="search"
                  label="入库类型"
                  single-line
                  hide-details="auto"
                  param="STORAGE_TYPE"/>
            </v-col>
            <v-col cols="2" xs="2" class="pb-0 pr-0">
              <z-source-selector
                  clearable v-model="queryRequest.state"
                  prepend-inner-icon="search"
                  label="入库状态"
                  single-line
                  hide-details="auto"
                  param="STORAGE_STATE"/>
            </v-col>
            <v-col cols="2" xs="2" class="pb-0 pr-0">
              <v-text-field
                  @keydown.enter="queryPageReset"
                  clearable v-model="queryRequest.applicant"
                  prepend-inner-icon="search"
                  label="申请人"
                  single-line
                  hide-details="auto"/>
            </v-col>
            <v-col cols="2" class="pb-0 pr-0">
              <v-text-field
                  @keydown.enter="queryPageReset"
                  label="采购申请单号"
                  hide-details="auto"
                  prepend-inner-icon="search"
                  clearable
                  v-model="queryRequest.purchaseApplyNo"/>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="2" class="pb-0">
              <v-text-field
                  @keydown.enter="queryPageReset"
                  label="关联出库单"
                  hide-details="auto"
                  prepend-inner-icon="search"
                  clearable
                  v-model="queryRequest.relatedOutboundNo"/>
            </v-col>

            <v-col cols="2" class="pb-0">
              <z-source-selector
                  hide-details="auto"
                  label="虚拟状态"
                  param="VIRTUAL_STATE"
                  v-model="queryRequest.virtualState"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <z-source-selector
                  hide-details="auto"
                  source="CompanyDicSelector"
                  label="来源"
                  multiple
                  param="MATERIAL_SOURCE"
                  v-model="queryRequest.resources"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field
                  @keydown.enter="queryPageReset"
                  hide-details="auto"
                  label="入库物料"
                  prepend-inner-icon="search"
                  clearable
                  v-model="queryRequest.materialsInfo"/>
            </v-col>

            <v-col cols="4" xs="2"
                   class="pb-0 d-flex flex-wrap align-self-end">
              <v-badge
                  :content="querySelected"
                  :value="querySelected!=0"
                  color="green"
                  overlap
              >
                <v-btn small :loading="isSearchLoading"
                       color="primary"
                       @click="queryPageReset">
                  搜索
                </v-btn>
              </v-badge>

              <v-btn small color="primary"
                     class="ml-2"
                     @click="resetQuery">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn small color="primary" class="ml-2"
                     @click.stop="storageApplyOpen">
                添加入库申请单
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                      v-on="on"
                      class="ml-2"
                      icon
                      color="primary"
                      @click="extend">
                    <v-icon v-if="!seniorQueryFlag" large>mdi-arrow-down-drop-circle</v-icon>
                    <v-icon v-else large>mdi-arrow-up-drop-circle</v-icon>
                  </v-btn>
                </template>
                <span>高级搜索按钮</span>
              </v-tooltip>
              <v-btn small color="primary"
                     class="ml-2"
                     @click="report">一键导出
              </v-btn>
            </v-col>
          </v-row>
          <v-expand-transition>
            <div v-show="seniorQueryFlag">
              <!-- 第一行 -->
              <v-row>
                <v-col cols="2" class="pb-0">
                  <v-text-field
                      @keydown.enter="queryPageReset"
                      label="送货单号"
                      hide-details="auto"
                      prepend-inner-icon="search"
                      clearable
                      v-model="queryRequest.waybillNumber"/>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <z-select-day
                      :hide-details="'auto'"
                      label="申请"
                      :startDateRules="[]"
                      :endDateRules="[]"
                      clearable
                      v-model="queryRequest.createDateTime"/>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <z-select-day
                      :hide-details="'auto'"
                      label="审核"
                      :startDateRules="[]"
                      :endDateRules="[]"
                      clearable
                      v-model="queryRequest.auditDate"/>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <v-text-field
                      @keydown.enter="queryPageReset"
                      label="设备产品编号"
                      hide-details="auto"
                      prepend-inner-icon="search"
                      clearable
                      v-model="queryRequest.relatedEqpProdNo"/>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <v-text-field
                      @keydown.enter="queryPageReset"
                      label="设备名称"
                      hide-details="auto"
                      prepend-inner-icon="search"
                      clearable
                      v-model="queryRequest.relatedEqpName"/>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <v-text-field
                      @keydown.enter="queryPageReset"
                      label="设备品牌"
                      hide-details="auto"
                      prepend-inner-icon="search"
                      clearable
                      v-model="queryRequest.relatedEqpBrand"/>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <v-text-field
                      @keydown.enter="queryPageReset"
                      label="设备型号"
                      hide-details="auto"
                      prepend-inner-icon="search"
                      clearable
                      v-model="queryRequest.relatedEqpModel"/>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <z-source-selector
                      hide-details="auto"
                      label="退库类型"
                      param="WITHDRAWAL_TYPE"
                      v-model="queryRequest.withdrawalType"/>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <v-switch
                      v-model="queryRequest.isReversed"
                      @change="queryPageReset"
                      label="是否红冲"
                  ></v-switch>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-form>
      </v-col>
    </v-row>

    <!------------------------------------------ 表格数据展示 ----------------------------------------->
    <v-row class="d-flex justify-center">
      <v-col cols="11">
        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="list"
            disable-sort
            :options.sync="options"
            :page.sync="queryRequest.pagedQueryInfo.index"
            show-expand
            single-expand
            :footer-props="footerOptions"
            :server-items-length="total">

          <template v-slot:item.relatedOutboundNo="{ item }">
            <a @click="toJumpPage(item)">
              {{ item.relatedOutboundNo }}
            </a>
          </template>

          <template v-slot:item.materialInfoDesc="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                                    <span @click="showMaterInfos(item)"
                                          class="d-inline-block text-truncate"
                                          style="cursor: pointer;color: blue;max-width: 150px;"
                                          v-bind="attrs"
                                          v-on="on">
                                         {{ item.materialInfoDesc }}
                                    </span>
              </template>
              <span>{{ item.materialInfoDesc }}</span>
            </v-tooltip>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">

              <div style="padding:10px 0;">
                <span>退库类型</span>：
                <span>{{ item.withdrawalTypeDesc }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>采购申请单</span>：
                <span>{{ item.purchaseApplyNo }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>虚拟状态</span>：
                <span>{{ item.virtualStateDesc }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>送货单号</span>：
                <span>{{ item.waybillNumber }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>采购申请单号</span>：
                <span>{{ item.purchaseApplyNo }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>关联设备名称</span>：
                <span>{{ item.relatedEqpName }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>关联设备品牌</span>：
                <span>{{ item.relatedEqpBrand }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>关联设备型号</span>：
                <span>{{ item.relatedEqpModel }}</span>
              </div>
              <div v-if="item.state == '03'" style="padding:10px 0;">
                <span>拒绝原因</span>：
                <span>{{ item.refuseReason }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>入库办理人</span>：
                <span>{{ item.auditPerson }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>入库办理时间</span>：
                <span>{{ item.auditDate }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>备注</span>：
                <span>{{ item.remark }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>图片附件</span>：
                <v-row style="width: 98%;">
                  <v-col cols="4"
                         v-for="(itemImg,index) in item.imgInfoList"
                         :key="index">
                    <v-img :src="itemImg"
                           @click="showImg(itemImg)"
                           aspect-ratio="1.7"
                           contain></v-img>
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>

          <template v-slot:item.opr="{ item }">
            <v-btn v-show="item.state == '01'" small color="primary" width="83px"
                   @click="storageHandleOpen(item)">
              办理入库
            </v-btn>
            <v-btn v-show="item.state == '03'" small color="error" width="83px" @click.stop="reApply(item)">
              重新申请
            </v-btn>
            <v-btn v-show="item.state == '02'" small color="deep-purple lighten-2" dark disabled>
              生成入库单
            </v-btn>
            <v-btn small color="secondary" width="83px" style="margin-left:  10px"
                   @click="storageReportOpen(item)">
              核验单
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!------------------------------------------ 入库申请单 ----------------------------------------->
    <v-dialog v-model="dialog" max-width="1400px">
      <v-card>
        <v-card-title>
          <span class="headline">填写入库申请单</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-form ref="dialogForm">

              <v-row>
                <v-col cols="1" class="pt-6 pr-0">
                  <span style="color: red">*</span><span>  请选择仓库: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector v-if="!wmsMngFlag" source="WarehouseSelector" label="请选择仓库" param=""
                                     v-model="storageApplyRequest.applyWarehouseId"
                                     :rules="[v => !!v || '目标仓库必选']"
                                     hide-details="auto"></z-source-selector>
                  <z-source-selector v-else source="WareHouseWmsManagerSelector" label="请选择仓库" param=""
                                     v-model="storageApplyRequest.applyWarehouseId"
                                     :rules="[v => !!v || '目标仓库必选']"
                                     hide-details="auto"></z-source-selector>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span style="color: red">*</span><span>  入库类型: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector label="请选择入库类型" param="STORAGE_TYPE_1"
                                     :rules="[v => !!v || '入库类型必选']"
                                     v-model="storageApplyRequest.storageType"
                                     hide-details="auto"></z-source-selector>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span style="color: red">*</span><span>  虚拟状态: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector label="请选择虚拟状态" param="VIRTUAL_STATE"
                                     :rules="[v => !!v || '虚拟状态必选']"
                                     v-model="storageApplyRequest.virtualState"
                                     hide-details="auto"></z-source-selector>
                </v-col>

              </v-row>

              <v-row>
                <v-col cols="1" class="pt-6 pr-0">
                  <span style="color: red">*</span><span> 入库单号: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector label="请选择入库单类型" param="STORAGE_ORDER_TYPE"
                                     :rules="[v => !!v || '入库单号必选']"
                                     v-model="storageApplyRequest.storageNoType"
                                     hide-details="auto"></z-source-selector>
                </v-col>
                <!--                                @changevalue="getInboundNo()"-->

                <!--                                <v-col cols="1" class="pt-6 pr-0">-->
                <!--                                    <span v-show="storageApplyRequest.storageNo != ''">{{ storageApplyRequest.storageNo }}</span>-->
                <!--                                </v-col>-->
                <!--                                <v-col cols="4" class="pt-0 pl-0">-->
                <!--                                </v-col>-->
                <v-col cols="1" class="pt-6 pr-0">
                  <span>采购申请单号: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入采购申请单号"
                                v-model="storageApplyRequest.purchaseApplyNo"
                                clearable
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>货运方: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入货运方"
                                v-model="storageApplyRequest.freightForwarder"
                                clearable
                                hide-details="auto"/>
                </v-col>

              </v-row>

              <v-row>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>送货单号: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入送货单号/凭证单号"
                                clearable
                                v-model="storageApplyRequest.waybillNumber"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>送货包装: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector label="请选择包装类型" param="WAYBILL_PACKAGING"
                                     v-model="storageApplyRequest.waybillPackaging"
                                     hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span style="color: red">*</span><span> 来源: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector label="请选择物料来源" source="CompanyDicSelector"
                                     v-model="storageApplyRequest.resources"
                                     :rules="[v => !!v || '来源必选']"
                                     param="MATERIAL_SOURCE" hide-details="auto"/>
                </v-col>
              </v-row>

              <v-row>

                <v-col cols="1" class="pt-6 pr-0">
                                    <span v-show="storageApplyRequest.storageType === '06' "
                                          style="color: red">*</span><span> 关联出库单号: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入关联出库单号"
                                clearable
                                v-model="storageApplyRequest.relatedOutboundNo"
                                :rules="[
                                      v => (storageApplyRequest.storageType === '06')?!!v||'入库类型为“退库”时，必须输入关联出库单号':true
                                    ]"
                                hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                                    <span v-show="storageApplyRequest.storageType == '06' "
                                          style="color: red">*</span><span> 退库类型: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector label="请选择退库类型" param="WITHDRAWAL_TYPE"
                                     :isDisabled="storageApplyRequest.storageType != '06'"
                                     v-model="storageApplyRequest.withdrawalType"
                                     :rules="[
                                        v => (storageApplyRequest.storageType == '06')?!!v||'入库类型为“退库”时，必须选择退库类型':true
                                      ]"
                                     hide-details="auto"/>
                </v-col>

                <v-col cols="1" class="pt-6 pr-0">
                  <span style="color: red">*</span><span>申请人: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="申请人"
                                clearable
                                :rules="[v => !!v || '申请人必选']"
                                v-model="storageApplyRequest.applicant"
                                hide-details="auto"/>
                </v-col>

              </v-row>

              <v-row>
                <v-col cols="1" class="pt-3 pl-0">
                  <v-btn width="100px" color="primary"
                         @click="baseEqpInfoDialog = !baseEqpInfoDialog">获取基础数据
                  </v-btn>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>关联设备型号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <v-text-field label="请输入设备型号" v-model="storageApplyRequest.relatedEqpModel"
                                :disabled="true"
                                hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>关联设备名称: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备名称" v-model="storageApplyRequest.relatedEqpName"
                                :disabled="true"
                                hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>关联设备品牌: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备品牌" v-model="storageApplyRequest.relatedEqpBrand"
                                :disabled="true"
                                hide-details="auto"></v-text-field>
                </v-col>

              </v-row>

              <v-row>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>备注: </span>
                </v-col>
                <v-col class="pt-0 pl-0">
                  <v-textarea
                      counter
                      auto-grow
                      row-height="5"
                      label="备注"
                      :rules="[v => !v || v.length <= 256 || '限制字数256']"
                      v-model="storageApplyRequest.remark"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="1" class="pt-6 pr-0">
                  <span> 图片附件: </span>
                </v-col>
                <v-col cols="5" class="pt-0 pl-0" style="display: flex">
                  <div style="position: absolute">只能上传.jpg文件，且不超过2MB，最多上传5张</div>
                  <v-file-input
                      v-if="storageApplyRequest.imgFile&&storageApplyRequest.imgFile.length<5"
                      v-model="imgFile"
                      accept="image/jpeg, image/jpg"
                      placeholder="Pick an avatar"
                      @change="uploadImgFile"
                      :loading="uploadIsImgLoading"
                      prepend-icon="mdi-camera"
                      :hide-input="true"
                      style="flex:none"
                  ></v-file-input>
                  <template v-for="(item,index) in storageApplyRequest.imgFile">
                    <div :key="item+index" style="position: relative;margin-top: 20px">
                      <img style="width: 200px;height: 200px;margin: 5px;cursor: pointer;"
                           :src="item.url" @click="showImg(item.url)" :key="item.key" class="img-show">
                      <button type="button" @click="deleteImg(index)" aria-label="clear icon"
                              class="v-icon notranslate v-icon--link mdi mdi-close theme--light img-close"></button>
                    </div>
                  </template>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="1" class="pt-6 pr-0">
                  <span style="color: red">*</span><span> 入库物料明细: </span>
                </v-col>
                <v-col cols="5" class="pt-0 pl-0">
                  <v-file-input accept=".xls,.xlsx" label="只能上传excel:xls文件，文件内容条数少于2000"
                                v-model="fileInfo"
                                :rules="[v => !!v || '入库物料明细必须上传']"
                                :loading="uploadIsLoading"
                                @change="uploadFile"></v-file-input>
                </v-col>
                <v-col cols="5" class="pt-3 pl-0">
                  <v-btn color="primary" @click="getMould">获取模板</v-btn>
                </v-col>

              </v-row>

              <v-row>
                <v-col cols="1"></v-col>
                <v-col cols="5">
                  <v-card
                      class="ml-5"
                      width="800"
                      max-width="1400"
                  >
                    <v-row>
                      <v-col cols="5">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>只能上传excel:xls文件，且文件内容条数少于2000
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>导入数据总数:{{ importInfo.total }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>处理失败数量:{{ importInfo.fail }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>成功总数量:{{ importInfo.success }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>更新数量:{{ importInfo.update }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>新增数量:{{ importInfo.insert }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>处理耗时:{{ importInfo.spendTime }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col>
                        <v-simple-table
                            dense
                        >
                          <template v-slot:default>
                            <thead>
                            <tr>
                              <th class="text-left">表格序号</th>
                              <th class="text-left">错误原因</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in failInfoList" :key="item.index">
                              <td>{{ item.index }}</td>
                              <td>{{ item.error }}</td>
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="submitLoadding" color="primary" width="100px" @click="storageApply" dark>提交入库申请
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="imgDialog">
      <v-card>
        <v-img :src="imgUrl"></v-img>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exportLoading"
              fullscreen
              overlay-color="white">
      <div
          style="width: 100%;height: 100%;background-color: rgba(255,255,255,0.5);display: flex;align-items: center;justify-content: center">
        <div style="text-align: center">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          >
          </v-progress-circular>
          <br/>
          <p style="margin-top: 10px; color: blue">报表生成中,请稍等...</p>
        </div>
      </div>
    </v-dialog>

    <!------------------------------------------ 办理入库 ----------------------------------------->
    <v-dialog v-model="storageHandleDialog" max-width="1500px">
      <v-card>
        <v-card-title>
          <span class="headline">办理入库</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0" style="max-width: 90%">
            <v-row>
              <!------------------------------------------ 第一行 ----------------------------------------->
              <v-col cols="1" class="pt-3 pr-0">
                <span>目标仓库:</span>
              </v-col>
              <v-col cols="3" class="pt-0 pr-0 pa-0">
                <z-source-selector v-if="!wmsMngFlag" hideDetails="auto" class="pt-0 " source="WarehouseSelector"
                                   :rules="[v => !!v || '目标仓库必选']"
                                   v-model="storageHandleData.aimsWarehouseId"
                                   :value="storageHandleData.aimsWarehouseId"></z-source-selector>
                <z-source-selector v-else hideDetails="auto" class="pt-0 " source="WareHouseWmsManagerSelector"
                                   :rules="[v => !!v || '目标仓库必选']"
                                   v-model="storageHandleData.aimsWarehouseId"
                                   :value="storageHandleData.aimsWarehouseId"></z-source-selector>
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>入库类型: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.storageTypeDesc }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>虚拟状态: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.virtualState }}
              </v-col>
              <!------------------------------------------ 第二行 ----------------------------------------->
              <v-col cols="1" class="pt-3 pr-0">
                <span>入库单号: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.storageNo }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>入库申请人:</span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.applicant }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>申请时间: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.createDateTime }}
              </v-col>


              <!------------------------------------------ 第三行 ----------------------------------------->
              <v-col cols="1" class="pt-3 pr-0">
                <span>货运方: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.freightForwarder }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>送货单号:</span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.waybillNumber }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>送货包装: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.waybillPackaging }}
              </v-col>


              <!------------------------------------------ 第四行 ----------------------------------------->
              <v-col cols="1" class="pt-3 pr-0">
                <span>来源: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.resourcesDesc }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>关联出库单号:</span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.relatedOutboundNo }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>采购申请单号: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.purchaseApplyNo }}
              </v-col>


              <!------------------------------------------ 第五行 ----------------------------------------->
              <v-col cols="1" class="pt-3 pr-0">
                <span>设备名称: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.relatedEqpName }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>设备品牌:</span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.relatedEqpBrand }}
              </v-col>
              <v-col cols="1" class="pt-3 pr-0">
                <span>设备型号: </span>
              </v-col>
              <v-col cols="3" class="pt-3 pl-0">
                {{ storageHandleData.relatedEqpModel }}
              </v-col>

              <!------------------------------------------ 第五行 ----------------------------------------->
              <v-col cols="1" class="pt-6 pr-0">
                <span style="color: red" v-if="storageHandleData.requestId">*</span>
                <span> 上传图片（快递单、包装外观）: </span>
              </v-col>
              <v-col cols="5" class="pt-6 pl-10" style="display: flex">
                <div style="position: absolute">只能上传.jpg文件，且不超过2MB，最多上传3张</div>
                <v-file-input
                    v-if="storageHandleData.packagePicList&&storageHandleData.packagePicList.length<3"
                    v-model="imgFile"
                    accept="image/*"
                    placeholder="Pick an avatar"
                    @change="uploadImgOtherFile(storageHandleData.packagePicList)"
                    :loading="uploadIsImgLoading"
                    prepend-icon="mdi-camera"
                    :hide-input="true"
                    style="flex:none"
                ></v-file-input>
                <template v-for="(item,index) in storageHandleData.packagePicList">
                  <div :key="item+index" style="position: relative;margin-top: 20px">
                    <img style="width: 150px;height: 150px;margin: 5px;cursor: pointer;"
                         :src="item" @click="showImg(item)" :key="item" class="img-show">
                    <button type="button" @click="deleteImg(storageHandleData.packagePicList,index)"
                            aria-label="clear icon"
                            class="v-icon notranslate v-icon--link mdi mdi-close theme--light img-close"></button>
                  </div>
                </template>
              </v-col>
              <v-col cols="1" class="pt-6 pr-0">
                <span style="color: red" v-if="storageHandleData.requestId">*</span>
                <span> 上传图片（供应商送货单、备件外观、铭牌）: </span>
              </v-col>
              <v-col cols="5" class="pt-6 pl-10" style="display: flex">
                <div style="position: absolute">只能上传.jpg文件，且不超过2MB，最多上传3张</div>
                <v-file-input
                    v-if="storageHandleData.accInfoPicList&&storageHandleData.accInfoPicList.length<3"
                    v-model="imgFile"
                    accept="image/*"
                    placeholder="Pick an avatar"
                    @change="uploadImgOtherFile(storageHandleData.accInfoPicList)"
                    :loading="uploadIsImgLoading"
                    prepend-icon="mdi-camera"
                    :hide-input="true"
                    style="flex:none"
                ></v-file-input>
                <template v-for="(item,index) in storageHandleData.accInfoPicList">
                  <div :key="item+index" style="position: relative;margin-top: 20px">
                    <img style="width: 150px;height: 150px;margin: 5px;cursor: pointer;"
                         :src="item" @click="showImg(item)" :key="item" class="img-show">
                    <button type="button" @click="deleteImg(storageHandleData.accInfoPicList,index)"
                            aria-label="clear icon"
                            class="v-icon notranslate v-icon--link mdi mdi-close theme--light img-close"></button>
                  </div>
                </template>
              </v-col>
              <!------------------------------------------ 第六行 ----------------------------------------->
              <v-col cols="4" class="pt-3 pr-0">
                <span>本次入库物料信息: </span>
              </v-col>
              <v-col cols="6" class="pt-3 pr-0">
                <span>备注: {{ storageHandleData.remark }}</span>
              </v-col>
              <!------------------------------------------ 第七行 ----------------------------------------->
              <v-col cols="12">
                <v-data-table
                    show-expand
                    disable-sort
                    hide-default-footer
                    :headers="materialInfoListHeader"
                    :items="storageHandleData.materialInfoList"
                    class="elevation-1"
                    disable-pagination
                >
                  <template v-slot:item.attachedInfo="{ item }">
                    {{ (item.attachedInfo && item.attachedInfo.picInfos) ? item.attachedInfo.picInfos.length : 0 }}
                  </template>
                  <template v-slot:item.storageLocation="{ item }">
                    <v-text-field
                        class="input-center"
                        v-model="item.storageLocation"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.factSerialNo="{ item }">
                    <v-text-field v-if="item.needSerialNoFlag"
                                  class="input-center"
                                  v-model="item.factSerialNo"
                    ></v-text-field>
                    <span v-else>
                    {{ item.factSerialNo }}
                    </span>
                  </template>
                  <template v-slot:item.businessLabel="{ item }">
                    <z-source-selector v-if="item.materielType == '1'" hideDetails="auto" class="pt-0"
                                       param="BUSINESS_TAG"
                                       v-model="item.businessLabel"></z-source-selector>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <span>图片信息</span>：
                      <div style="padding:10px 0;"
                           v-if="item.attachedInfo && item.attachedInfo.picInfos">
                        <v-row style="width: 98%;">
                          <v-col cols="4"
                                 v-for="(itemImg,index) in item.attachedInfo.picInfos"
                                 :key="index">
                            <v-img :src="itemImg"
                                   aspect-ratio="1.7"
                                   contain></v-img>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </v-col>

              <!------------------------------------------ 第八行 ----------------------------------------->
              <v-col v-if="storageHandleData.outMaterialInfoList" cols="12" class="pt-3 pr-0">
                <span>关联出库单号<span style="color: blue;">{{ storageHandleData.relatedOutboundNo }}</span>的出库物料信息: </span>
              </v-col>

              <!------------------------------------------ 第九行 ----------------------------------------->
              <v-col cols="12" v-if="storageHandleData.outMaterialInfoList">
                <v-data-table
                    style="width: 100%;"
                    :headers="outMaterialsHeaders"
                    :items="storageHandleData.outMaterialInfoList"
                    :server-items-length="storageHandleData.outMaterialInfoList.length"
                    hide-default-footer
                    disable-sort>
                  <template v-slot:item.specification="{ item }">
                    {{
                      (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                      + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                    }}
                  </template>
                  <template v-slot:item.oneReturnWhseNum="{ item }">
                    <div style="align-items: center; display: flex; flex-direction: column;">
                      <v-text-field id="oneReturnWhseNum"
                                    v-model="item.oneReturnWhseNum"/>
                    </div>
                  </template>
                  <template v-slot:item.withdrawalFlag="{ item }">
                    {{ item.withdrawalFlag ? '需退库' : '不需要退库' }}
                  </template>
                </v-data-table>
              </v-col>

            </v-row>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-2" width="100px" @click="storageRefuseOpen(storageHandleData.id)" dark>
            拒绝入库
          </v-btn>
          <v-btn :loading="storageHandleLoading" color="blue darken-1" width="100px" @click="storageHandle"
                 dark>办理入库
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!------------------------------------------ 入库核验单 ----------------------------------------->
    <v-dialog v-model="storageReportDialog" max-width="1400px">
      <div style="background-color: white" class="pa-0">
        <v-row
            class="mb-3"
            no-gutters>
          <v-col cols="5" class="mt-3">
            <v-btn class="ml-1 mr-1" small color="black" @click="workSheetPrint" outlined dark>
              <v-icon>print</v-icon>
              打印
            </v-btn>
            <v-btn class="mr-1" small color="black" outlined @click="getPdf('#pdfDom1','入库核验单')" dark>
              <v-icon>save_alt</v-icon>
              下载
            </v-btn>
            <v-btn class="mr-1" small color="black" outlined @click="storageReportDialog = !storageReportDialog" dark>
              <v-icon>close</v-icon>
              关闭
            </v-btn>
            <br>
          </v-col>
        </v-row>
        <section ref="print" class="">
          <div id="pdfDom" class="work-sheet pb-7" style="line-height: 30px;">
            <h2 style="text-align: center">入库核验单</h2>
            <v-row no-gutters>
              <v-col cols="6">
              </v-col>
              <v-col>
                <div style="float: right; display: table">
                  <img :src="base64LogoImg" style="width: 90px;height: 30px; display: table-cell"/>
                  <span
                      v-if="storageReportData.serviceHotline && storageReportData.serviceHotline.length > 0">全国服务热线：{{
                      storageReportData.serviceHotline
                    }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <b>基础信息</b>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span>入库单号：</span> {{ storageReportData.storageNo }}
              </v-col>
              <v-col cols="4">
                <span>入库类型：</span> {{ storageReportData.storageTypeDesc }}
              </v-col>
              <v-col cols="4">
                <span>虚拟状态：</span>{{ storageReportData.virtualStateDesc }}
              </v-col>
              <v-col cols="4">
                <span>入库申请人：</span>{{ storageReportData.applicant }}
              </v-col>
              <v-col cols="4">
                <span>申请时间：</span>{{ storageReportData.createDateTime }}
              </v-col>
              <v-col cols="4">
                <span>采购申请单号：</span>{{ storageReportData.purchaseApplyNo }}
              </v-col>
              <v-col cols="4">
                <span>关联出库单号：</span>{{ storageReportData.relatedOutboundNo }}
              </v-col>
              <v-col cols="4">
                <span>目标仓库：</span>{{ storageReportData.aimsWarehouseName }}
              </v-col>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters>
              <b>货运信息</b>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span>货运方：</span>{{ storageReportData.freightForwarder }}
              </v-col>
              <v-col cols="4">
                <span>送货单号：</span> {{ storageReportData.waybillNumber }}
              </v-col>
              <v-col cols="4">
                <span>送货包装：</span> {{ storageReportData.waybillPackagingDesc }}
              </v-col>
              <v-col cols="4">
                <span>来源：</span>{{ storageReportData.resourcesDesc }}
              </v-col>
              <v-col cols="4">
                <span>设备名称：</span>{{ storageReportData.relatedEqpName }}
              </v-col>
              <v-col cols="4">
                <span>设备品牌：</span>{{ storageReportData.relatedEqpBrand }}
              </v-col>
              <v-col cols="12">
                <span>设备型号：</span>{{ storageReportData.relatedEqpModel }}
              </v-col>
              <v-col cols="1" class="pt-6 pr-0">
                <span> 图片（快递单、包装外观）: </span>
              </v-col>
              <v-col cols="5">
                <template v-for="(item,index) in storageReportData.packagePicList">
                  <div :key="item+index" style="position: relative;margin-top: 20px">
                    <img style="width: 150px;height: 150px;margin: 5px;cursor: pointer;"
                         :src="item" @click="showImg(item)" :key="item" class="img-show">
                  </div>
                </template>
              </v-col>
              <v-col cols="1" class="pt-6 pr-0">
                <span> 图片（供应商送货单、备件外观、铭牌）: </span>
              </v-col>
              <v-col cols="5">
                <template v-for="(item,index) in storageReportData.accInfoPicList">
                  <div :key="item+index" style="position: relative;margin-top: 20px">
                    <img style="width: 150px;height: 150px;margin: 5px;cursor: pointer;"
                         :src="item" @click="showImg(item)" :key="item" class="img-show">
                  </div>
                </template>
              </v-col>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters>
              <b>入库物料信息</b>
            </v-row>
            <v-row>
              <table class="work-sheet-table" center border="0" cellpadding="0" cellspacing="0">
                <tr>
                  <td class="text-center">序号</td>
                  <td class="text-center">物料产品编号</td>
                  <td class="text-center">库位</td>
                  <td class="text-center">物料名称</td>
                  <td class="text-center">品牌</td>
                  <td class="text-center">型号</td>
                  <td class="text-center">规格</td>
                  <td class="text-center">出厂序列号</td>
                  <td class="text-center">采购物料唯一标识</td>
                  <td class="text-center">状态</td>
                  <td class="text-center">数量</td>
                  <td class="text-center">单价</td>
                  <td class="text-center">单价(不含税)</td>
                  <td class="text-center">税率</td>
                  <td class="text-center">计量单位</td>
                  <td class="text-center">关联工单</td>
                </tr>
                <tr v-for="(item,index) in storageReportData.materialInfoList" :key="index"
                    class="text-center">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.materielProdNo }}</td>
                  <td>{{ item.storageLocation }}</td>
                  <td>{{ item.materielName }}</td>
                  <td>{{ item.materielBrand }}</td>
                  <td>{{ item.materielModel }}</td>
                  <td>{{ item.specificationAll }}</td>
                  <td>{{ item.factSerialNo }}</td>
                  <td>{{ item.purchaseMaterielId }}</td>
                  <td>{{ item.stateDesc }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.unitPrice }}</td>
                  <td>{{ item.noTaxUnitPrice }}</td>
                  <td>{{ item.taxRate }}</td>
                  <td>{{ item.unit }}</td>
                  <td></td>
                </tr>
              </table>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters class="mt-3">
              <v-col cols="1" class="pt-3 pr-0">
                <b>备注</b>
              </v-col>
              <v-col cols="8" class="pt-3 pl-0">
                {{ storageReportData.remark }}
              </v-col>
            </v-row>
          </div>
        </section>
        <section class="printCopy" style="width: 1400px;position: absolute;top: -10px;opacity: 0;z-index: -1">
          <div id="pdfDom1" class="work-sheet pb-7" style="line-height: 30px;font-size: 20px;">
            <h2 style="text-align: center">入库核验单</h2>
            <v-row no-gutters>
              <v-col cols="6">
              </v-col>
              <v-col>
                <div style="float: right; display: table">
                  <img :src="base64LogoImg" style="width: 90px;height: 30px; display: table-cell"/>
                  <span
                      v-if="storageReportData.serviceHotline && storageReportData.serviceHotline.length > 0">全国服务热线：{{
                      storageReportData.serviceHotline
                    }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <b>基础信息</b>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span>入库单号：</span> {{ storageReportData.storageNo }}
              </v-col>
              <v-col cols="4">
                <span>入库类型：</span> {{ storageReportData.storageTypeDesc }}
              </v-col>
              <v-col cols="4">
                <span>虚拟状态：</span>{{ storageReportData.virtualStateDesc }}
              </v-col>
              <v-col cols="4">
                <span>入库申请人：</span>{{ storageReportData.applicant }}
              </v-col>
              <v-col cols="4">
                <span>申请时间：</span>{{ storageReportData.createDateTime }}
              </v-col>
              <v-col cols="4">
                <span>采购申请单号：</span>{{ storageReportData.purchaseApplyNo }}
              </v-col>
              <v-col cols="4">
                <span>关联出库单号：</span>{{ storageReportData.purchaseApplyNo }}
              </v-col>
              <v-col cols="4">
                <span>目标仓库：</span>{{ storageReportData.aimsWarehouseName }}
              </v-col>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters>
              <b>货运信息</b>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span>货运方：</span>{{ storageReportData.freightForwarder }}
              </v-col>
              <v-col cols="4">
                <span>送货单号：</span> {{ storageReportData.waybillNumber }}
              </v-col>
              <v-col cols="4">
                <span>送货包装：</span> {{ storageReportData.waybillPackaging }}
              </v-col>
              <v-col cols="4">
                <span>来源：</span>{{ storageReportData.resourcesDesc }}
              </v-col>
              <v-col cols="4">
                <span>设备名称：</span>{{ storageReportData.relatedEqpName }}
              </v-col>
              <v-col cols="4">
                <span>设备品牌：</span>{{ storageReportData.relatedEqpBrand }}
              </v-col>
              <v-col cols="4">
                <span>设备型号：</span>{{ storageReportData.relatedEqpModel }}
              </v-col>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters>
              <b>入库物料信息</b>
            </v-row>
            <v-row>
              <table class="work-sheet-table" center border="0" cellpadding="0" cellspacing="0"
                     style="font-size: 18px;">
                <tr>
                  <td class="text-center">序号</td>
                  <td class="text-center">物料产品编号</td>
                  <td class="text-center">库位</td>
                  <td class="text-center">物料名称</td>
                  <td class="text-center">品牌</td>
                  <td class="text-center">型号</td>
                  <td class="text-center">规格</td>
                  <td class="text-center">出厂序列号</td>
                  <td class="text-center">采购物料唯一标识</td>
                  <td class="text-center">状态</td>
                  <td class="text-center">数量</td>
                  <td class="text-center">单价</td>
                  <td class="text-center">单价(不含税)</td>
                  <td class="text-center">税率</td>
                  <td class="text-center">计量单位</td>
                  <td class="text-center">关联工单</td>
                </tr>
                <tr v-for="(item,index) in storageReportData.materialInfoList" :key="index"
                    class="text-center">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.materielProdNo }}</td>
                  <td>{{ item.storageLocation }}</td>
                  <td>{{ item.materielName }}</td>
                  <td>{{ item.materielBrand }}</td>
                  <td>{{ item.materielModel }}</td>
                  <td>{{ item.specificationAll }}</td>
                  <td>{{ item.factSerialNo }}</td>
                  <td>{{ item.purchaseMaterielId }}</td>
                  <td>{{ item.stateDesc }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.unitPrice }}</td>
                  <td>{{ item.noTaxUnitPrice }}</td>
                  <td>{{ item.taxRate }}</td>
                  <td>{{ item.unit }}</td>
                  <td></td>
                </tr>
              </table>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters class="mt-3">
              <v-col cols="1" class="pt-3 pr-0">
                <b>备注</b>
              </v-col>
              <v-col cols="8" class="pt-3 pl-0">
                {{ storageReportData.remark }}
              </v-col>
            </v-row>
          </div>
        </section>
      </div>
    </v-dialog>

    <!------------------------------------------ 入库拒绝 ----------------------------------------->
    <v-dialog v-model="storageRefuseDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">拒绝入库</span>
        </v-card-title>
        <v-textarea
            counter="100"
            :rules="[v => v.length <= 100 || '最多不能超过100字']"
            v-model="storageRefuseRequest.refuseReason"
            color="teal"
            class="ma-5"
            outlined
            hide-detail="true"
            label="
              请输入拒绝原因"
        >
        </v-textarea>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" width="100px" @click="storageRefuse" :loading="storageRefuseLoading" dark>
            确认
          </v-btn>
          <v-btn color="error" width="100px" @click="storageRefuseDialog = false" dark>取消</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!------------------------------------------ 设备基础数据查询窗口 ----------------------------------------->
    <v-dialog v-model="baseEqpInfoDialog" width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">设备基础数据查询</span>
        </v-card-title>

        <v-card-text>
          <v-row justify="center"
                 class="mb-2"
                 no-gutters>
            <v-col cols="12">
              <v-form ref="queryForm">
                <v-row justify="center">
                  <v-col cols="2" xs="2" class="pb-0 pr-0">
                    <v-text-field
                        clearable v-model="queryEqpProdRequest.eqpName"
                        prepend-inner-icon="search"
                        label="设备名称"
                        single-line
                        hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" xs="2" class="pb-0 pr-0">
                    <v-text-field
                        clearable v-model="queryEqpProdRequest.eqpBrand"
                        prepend-inner-icon="search"
                        label="设备品牌"
                        single-line
                        hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" xs="2" class="pb-0 pr-0">
                    <v-text-field
                        clearable v-model="queryEqpProdRequest.eqpModel"
                        prepend-inner-icon="search"
                        label="设备型号"
                        single-line
                        hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5" xs="2" class="pb-0 pr-0">
                    <v-badge
                        :content="eqpInfoQuerySelected"
                        :value="eqpInfoQuerySelected!=0"
                        color="green"
                        overlap
                    >
                      <v-btn :loading="eqpInfoIsSearchLoading"
                             color="primary"
                             @click="eqpInfoQuery">
                        搜索
                      </v-btn>
                    </v-badge>

                    <v-btn color="primary"
                           class="ma-2"
                           @click="resetEqpInfoQuery">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>

                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center">
            <v-col cols="11">
              <v-data-table
                  v-model="eqpInfoSelected"
                  :headers="eqpInfoHeaders"
                  :items="eqpInfoList"
                  disable-sort
                  show-select
                  :single-select="true"
                  :options.sync="options2"
                  :page.sync="queryEqpProdRequest.pagedQueryInfo.index"
                  :footer-props="footerOptions"
                  :server-items-length="eqpInfoTotal">
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" width="100px" @click="getBaseEqpInfo" :disabled="eqpInfoSelected.length==0">
            确认
          </v-btn>
          <v-btn color="error" width="100px" @click="baseEqpInfoDialog = false" dark>取消</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--物料信息-->
    <v-dialog v-model="showMaterFlag" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">物料详细信息</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-form ref="auditForm">
              <v-row>
                <v-data-table
                    style="width: 100%;"
                    :headers="selectedMaterHeaders"
                    :items="tableMaterInfos"
                    :server-items-length="tableMaterInfos.length"
                    hide-default-footer
                    disable-sort>
                  <template v-slot:item.specification="{ item }">
                    {{
                      (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                      + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                    }}
                  </template>
                  <template v-slot:item.withdrawalFlag="{ item }">
                    {{ item.withdrawalFlag ? '需退库' : '不需要退库' }}
                  </template>
                </v-data-table>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" width="100px" @click="showMaterFlag = false" dark>关闭</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--附件信息-->
    <!--        <v-dialog v-model="attachedInfoDialog" max-width="1100px">-->
    <!--            <v-card>-->
    <!--                <v-card-title>-->
    <!--                    <span class="headline">物料附件资料</span>-->
    <!--                </v-card-title>-->
    <!--                <v-card-text>-->
    <!--                    <v-container class="pa-0">-->
    <!--                        <v-form ref="auditForm">-->
    <!--                            <v-row>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>物料名称:</span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.materielName }}-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>品牌: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.materielBrand }}-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>型号: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.materielModel }}-->
    <!--                                </v-col>-->
    <!--                            </v-row>-->
    <!--                            <v-row>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>规格: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{(uploadMaterialInfo.specification?uploadMaterialInfo.specification:'')+(uploadMaterialInfo.specification2?'-'+uploadMaterialInfo.specification2:'')-->
    <!--                                    +(uploadMaterialInfo.specification3?'-'+uploadMaterialInfo.specification3:'')+(uploadMaterialInfo.specification4?'-'+uploadMaterialInfo.specification4:'')}}-->
    <!--                                </v-col>-->

    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>出厂序列号: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.factSerialNo }}-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>状态: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.stateDesc }}-->
    <!--                                </v-col>-->
    <!--                            </v-row>-->
    <!--                            <v-row>-->
    <!--                                &lt;!&ndash;                              <v-file-input prepend-icon="mdi-camera"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                            multiple label="点击上传"/>&ndash;&gt;-->
    <!--                                &lt;!&ndash;                              <v-file-input multiple :counter="10" small-chips&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      v-model="uploadMaterialInfo.attachedInfo"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      required&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      :rules="[v => !!v || '文件必选']"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      show-size&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      @change="uploadAnnex()"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      label="点击选择文件，文件格后缀为：.xls、.xlsx"/>&ndash;&gt;-->
    <!--                                <v-file-input-->
    <!--                                        v-if="uploadMaterialInfo.attachedInfo&&uploadMaterialInfo.attachedInfo.length<10"-->
    <!--                                        v-model="annexFileInfo"-->
    <!--                                        required-->
    <!--                                        show-size-->
    <!--                                        :hide-input="true"-->
    <!--                                        @change="uploadAnnexFile"-->
    <!--                                        :disabled="loading.uploadIsLoading"-->
    <!--                                        :loading="loading.uploadIsLoading"-->
    <!--                                        label="选择附件资料（最多10个）">-->
    <!--                                </v-file-input>-->
    <!--                            </v-row>-->
    <!--                            <v-row v-if="uploadMaterialInfo.attachedInfo&&uploadMaterialInfo.length>0">-->
    <!--                                <v-col cols="4"-->
    <!--                                       v-for="(item,index) in uploadMaterialInfo.attachedInfo"-->
    <!--                                       :key="index"-->
    <!--                                       style="position:relative;border:1px solid #ddd;">-->
    <!--                                    <v-img :src="item.url"-->
    <!--                                           aspect-ratio="1.7"-->
    <!--                                           contain></v-img>-->
    <!--                                    <div class="d-flex justify-center align-center mt-1"-->
    <!--                                         style="position:absolute;top:10px;right:10px;">-->
    <!--                                        <v-btn small color="primary" icon-->
    <!--                                               class="ml-1"-->
    <!--                                               @click="deleteImg(index)">-->
    <!--                                            <v-icon>mdi-delete</v-icon>-->
    <!--                                        </v-btn>-->
    <!--                                    </div>-->
    <!--                                    <div v-if="index==0">(默认图)</div>-->
    <!--                                </v-col>-->
    <!--                            </v-row>-->

    <!--                        </v-form>-->
    <!--                    </v-container>-->
    <!--                </v-card-text>-->
    <!--                <v-card-actions>-->
    <!--                    <v-spacer></v-spacer>-->
    <!--                    <v-btn color="blue darken-1" width="100px" @click="attachedInfoDialog = false" dark>关闭</v-btn>-->
    <!--                    <v-spacer></v-spacer>-->
    <!--                </v-card-actions>-->
    <!--            </v-card>-->
    <!--        </v-dialog> <v-dialog v-model="attachedInfoDialog" max-width="1100px">-->
    <!--            <v-card>-->
    <!--                <v-card-title>-->
    <!--                    <span class="headline">物料附件资料</span>-->
    <!--                </v-card-title>-->
    <!--                <v-card-text>-->
    <!--                    <v-container class="pa-0">-->
    <!--                        <v-form ref="auditForm">-->
    <!--                            <v-row>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>物料名称:</span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.materielName }}-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>品牌: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.materielBrand }}-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>型号: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.materielModel }}-->
    <!--                                </v-col>-->
    <!--                            </v-row>-->
    <!--                            <v-row>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>规格: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{(uploadMaterialInfo.specification?uploadMaterialInfo.specification:'')+(uploadMaterialInfo.specification2?'-'+uploadMaterialInfo.specification2:'')-->
    <!--                                    +(uploadMaterialInfo.specification3?'-'+uploadMaterialInfo.specification3:'')+(uploadMaterialInfo.specification4?'-'+uploadMaterialInfo.specification4:'')}}-->
    <!--                                </v-col>-->

    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>出厂序列号: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.factSerialNo }}-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="1" class="pt-3 pr-0">-->
    <!--                                    <span>状态: </span>-->
    <!--                                </v-col>-->
    <!--                                <v-col cols="3" class="pt-3 pl-0">-->
    <!--                                    {{ uploadMaterialInfo.stateDesc }}-->
    <!--                                </v-col>-->
    <!--                            </v-row>-->
    <!--                            <v-row>-->
    <!--                                &lt;!&ndash;                              <v-file-input prepend-icon="mdi-camera"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                            multiple label="点击上传"/>&ndash;&gt;-->
    <!--                                &lt;!&ndash;                              <v-file-input multiple :counter="10" small-chips&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      v-model="uploadMaterialInfo.attachedInfo"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      required&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      :rules="[v => !!v || '文件必选']"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      show-size&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      @change="uploadAnnex()"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                      label="点击选择文件，文件格后缀为：.xls、.xlsx"/>&ndash;&gt;-->
    <!--                                <v-file-input-->
    <!--                                        v-if="uploadMaterialInfo.attachedInfo&&uploadMaterialInfo.attachedInfo.length<10"-->
    <!--                                        v-model="annexFileInfo"-->
    <!--                                        required-->
    <!--                                        show-size-->
    <!--                                        :hide-input="true"-->
    <!--                                        @change="uploadAnnexFile"-->
    <!--                                        :disabled="loading.uploadIsLoading"-->
    <!--                                        :loading="loading.uploadIsLoading"-->
    <!--                                        label="选择附件资料（最多10个）">-->
    <!--                                </v-file-input>-->
    <!--                            </v-row>-->
    <!--                            <v-row v-if="uploadMaterialInfo.attachedInfo&&uploadMaterialInfo.length>0">-->
    <!--                                <v-col cols="4"-->
    <!--                                       v-for="(item,index) in uploadMaterialInfo.attachedInfo"-->
    <!--                                       :key="index"-->
    <!--                                       style="position:relative;border:1px solid #ddd;">-->
    <!--                                    <v-img :src="item.url"-->
    <!--                                           aspect-ratio="1.7"-->
    <!--                                           contain></v-img>-->
    <!--                                    <div class="d-flex justify-center align-center mt-1"-->
    <!--                                         style="position:absolute;top:10px;right:10px;">-->
    <!--                                        <v-btn small color="primary" icon-->
    <!--                                               class="ml-1"-->
    <!--                                               @click="deleteImg(index)">-->
    <!--                                            <v-icon>mdi-delete</v-icon>-->
    <!--                                        </v-btn>-->
    <!--                                    </div>-->
    <!--                                    <div v-if="index==0">(默认图)</div>-->
    <!--                                </v-col>-->
    <!--                            </v-row>-->

    <!--                        </v-form>-->
    <!--                    </v-container>-->
    <!--                </v-card-text>-->
    <!--                <v-card-actions>-->
    <!--                    <v-spacer></v-spacer>-->
    <!--                    <v-btn color="blue darken-1" width="100px" @click="attachedInfoDialog = false" dark>关闭</v-btn>-->
    <!--                    <v-spacer></v-spacer>-->
    <!--                </v-card-actions>-->
    <!--            </v-card>-->
    <!--        </v-dialog>-->


    <z-notify ref="notify"></z-notify>
  </v-container>
</template>

<script>
import {dataChangedCountMixin, dataCatchMixin} from "@/mixin"
import {getBase64} from '@/utils/urlToData'
import reportDownLoad from "@/utils/reportDownLoad"
import {
  details,
  getCkInboundNo,
  getKyInboundNo,
  materialImport,
  materialTemplate,
  queryEqpProdList,
  ossUpload,
  queryRequest,
  reportExport,
  storageApply,
  storageHandle,
  storageRefuse
} from "@/api/storageApplyInfo";
import dataChangedCount from "@/utils/dataChangedCount";
import {mapGetters} from "vuex"

export default {
  name: "WarehousingManagement",
  data: () => ({
        model: 0,
        footerOptions: {
          itemsPerPageOptions: [10, 50, 100, 200]
        },
        //下载
        isLoading: false,
        exportLoading: false,
        options: {},
        options2: {},
        dialog: false,
        attachedInfoDialog: false,
        storageReportDialog: false,
        storageHandleDialog: false,
        storageRefuseDialog: false,
        baseEqpInfoDialog: false,
        seniorQueryFlag: false,
        isSearchLoading: false,
        eqpInfoIsSearchLoading: false,
        storageHandleLoading: false,
        uploadIsLoading: false,
        uploadIsImgLoading: false,
        submitLoadding: false,
        storageRefuseLoading: false,
        eqpInfoQuerySelected: 0,
        //入库单类型
        storageNoType: '',
        fileInfo: null,
        imgInfo: null,
        eqpInfoSelected: [],
        imgDialog: false,
        imgUrl: '',
        queryEqpProdRequest: {
          "id": "",
          "pagedQueryInfo": {
            "index": 1,
            "pageSize": 10
          },
          "compId": "",
          "eqpName": "",
          "eqpBrand": "",
          "eqpModel": "",
          "eqpType": ""
        },
        queryRequest: {
          "id": "",
          "pagedQueryInfo": {
            "index": 1,
            "pageSize": 10
          },
          "companyId": "",
          "applyWarehouseId": [],
          "storageType": "",
          "virtualState": "",
          "storageNo": "",
          "purchaseApplyNo": "",
          "freightForwarder": "",
          "waybillNumber": "",
          "waybillPackaging": "",
          "resources": [],
          "relatedOutboundNo": "",
          "withdrawalType": "",
          "relatedEqpProdNo": "",
          "relatedEqpName": "",
          "relatedEqpBrand": "",
          "relatedEqpModel": "",
          "applicant": "",
          "materialsInfo": "",
          "auditPerson": "",
          "auditDate": [],
          "refuseReason": "",
          "aimsWarehouseId": [],
          state: '',
          "createDateTime": [],
          isReversed: false
        },
        imgFile: null,
        storageApplyRequest: {
          "imgFile": [],
          "imgList": [],
          "applyWarehouseId": "",
          "storageType": "",
          "virtualState": "",
          "storageNo": "",
          "purchaseApplyNo": "",
          "freightForwarder": "",
          "waybillNumber": "",
          "waybillPackaging": "",
          "resources": "",
          "relatedOutboundNo": "",
          "withdrawalType": "",
          "relatedEqpProdNo": "",
          "relatedEqpName": "",
          "relatedEqpBrand": "",
          "relatedEqpModel": "",
          "materialsInfo": "",
          "remark": "",
          storageNoType: "",
        },
        storageHandleRequest: {
          aimsWarehouseId: "",
          id: "",
          outMaterialInfos: "",
          packagePicList: [],
          accInfoPicList: [],
          storageApplyMaterialInfos: {},
        },
        storageRefuseRequest: {
          refuseReason: "",
          id: ""
        },
        list: [],
        eqpInfoList: [],
        total: 0,
        eqpInfoTotal: 0,
        storageHandleData: {
          "packagePicList": [],
          "accInfoPicList": [],
        },
        storageReportData: {
          waybillPackagingDesc: '',
        },
        failInfoList: [],
        importInfo: [],
        base64LogoImg: "",
        headers1: [
          {text: '目标仓库', value: 'aimsWarehouseName', align: 'center',},
          {text: '入库单号', value: 'storageNo', align: 'center',},
          {text: '入库类型', value: 'storageTypeDesc', align: 'center',},
          {text: '来源', value: 'resourcesDesc', align: 'center',},
          {text: '关联出库单', value: 'relatedOutboundNo', align: 'center',},
          {text: '申请人', value: 'applicant', align: 'center',},
          {text: '申请日期', value: 'applyDate', align: 'center',},
          {text: '入库状态', value: 'stateDesc', align: 'center',},
          {text: '物料信息', value: 'materialInfoDesc', align: 'center',},
          {text: ' ', value: 'data-table-expand', align: 'center',},
        ],
        headers: [
          {text: '目标仓库', value: 'aimsWarehouseName', align: 'center',},
          {text: '入库单号', value: 'storageNo', align: 'center',},
          {text: '入库类型', value: 'storageTypeDesc', align: 'center',},
          {text: '来源', value: 'resourcesDesc', align: 'center',},
          {text: '关联出库单', value: 'relatedOutboundNo', align: 'center',},
          {text: '申请人', value: 'applicant', align: 'center',},
          {text: '申请日期', value: 'applyDate', align: 'center',},
          {text: '入库状态', value: 'stateDesc', align: 'center',},
          {text: '物料信息', value: 'materialInfoDesc', align: 'center',},
          {text: '操作', value: 'opr', align: 'center', width: 200},
          {text: ' ', value: 'data-table-expand', align: 'center',},
        ],
        eqpInfoHeaders: [
          {text: '设备产品编号', value: 'id',},
          {text: '设备名称', value: 'eqpName',},
          {text: '设备品牌', value: 'eqpBrand'},
          {text: '设备型号', value: 'eqpModel'},
        ],
        //物料信息
        showMaterFlag: false,
        tableMaterInfos: [],
        selectedMaterHeaders: [
          {text: '物料产品编号', value: 'materielProdNo', align: 'center'},
          {text: '物料唯一编码', value: 'materielId', align: 'center'},
          {text: '物料名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格', value: 'specification', align: 'center'},
          {text: '品类', value: 'category', align: 'center'},
          {text: '子类', value: 'subType', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
          {text: '采购物料唯一标识', value: 'purchaseMaterielId', align: 'center', width: 100},
          {text: '状态', value: 'stateDesc', align: 'center'},
          {text: '申请入库数量', value: 'quantity', align: 'center', width: 100,},
          {text: '计量单位', value: 'unit', align: 'center'},
          {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
          {text: '退库件标志', value: 'withdrawalFlag', align: 'center'},
        ],
        uploadMaterialInfo: {},
        annexFileInfo: null,
        loading: {
          uploadIsLoading: false
        },
        //出库物料信息
        outMaterialsHeaders: [
          {text: '物料产品编号', value: 'materielProdNo', align: 'center'},
          {text: '仓库', value: 'warehouseName', align: 'center'},
          {text: '库位', value: 'storageLocation', align: 'center'},
          {text: '物料名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格', value: 'specification', align: 'center'},
          {text: '品类', value: 'category', align: 'center'},
          {text: '子类', value: 'subType', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
          {text: '状态', value: 'stateDesc', align: 'center'},
          {text: '申请出库数量', value: 'applyNum', align: 'center', width: 100,},
          {text: '剩余数量', value: 'remainNum', align: 'center', width: 100,},
          {text: '退库数量', value: 'oneReturnWhseNum', align: 'center', width: 100,},
          {text: '计量单位', value: 'unit', align: 'center'},
          {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
          {text: '退库件标志', value: 'withdrawalFlag', align: 'center', width: 100,},
          {text: '单价', value: 'unitPrice', align: 'center'},
          {text: '单价(不含税)', value: 'noTaxUnitPrice', align: 'center'},
          {text: '税率', value: 'taxRate', align: 'center'},
        ],
        //入库物料明细
        materialInfoListHeader: [
          {text: '序号', value: 'index', align: 'center'},
          {text: '产品编号', value: 'materielProdNo', align: 'center'},
          {text: '名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格1', value: 'specification', align: 'center'},
          {text: '规格2', value: 'specification2', align: 'center'},
          {text: '规格3', value: 'specification3', align: 'center'},
          {text: '规格4', value: 'specification4', align: 'center'},
          {text: '数量', value: 'quantity', align: 'center'},
          {text: '计量单位', value: 'unit', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center', width: 100},
          {text: '采购物料唯一标识', value: 'purchaseMaterielId', align: 'center', width: 100},
          {text: '状态', value: 'stateDesc', align: 'center'},
          {text: '库位', value: 'storageLocation', align: 'center', width: 100},
          {text: '单价', value: 'unitPrice', align: 'center'},
          {text: '单价(不含税)', value: 'noTaxUnitPrice', align: 'center'},
          {text: '税率', value: 'taxRate', align: 'center'},
          {text: '采购数量', value: 'quantity', align: 'center'},
          {text: '关联工单', value: 'relSeqNo', align: 'center'},
          {text: '标签', value: 'businessLabel', align: 'center', width: 130},
          {text: '附件资料', value: 'attachedInfo', align: 'center'},
          {text: '', value: 'data-table-expand'},
        ],
      }
  ),
  computed: {
    ...mapGetters([
      "wmsMngFlag",
      "oaFlag"
    ]),
  },
  mixins: [dataChangedCountMixin, dataCatchMixin],
  watch: {
    options: {
      handler(val) {
        if (val.itemsPerPage == -1) {
          this.queryRequest.pagedQueryInfo.index = 1
          this.queryRequest.pagedQueryInfo.pageSize = 999999
        } else if (!!val.page && !!val.itemsPerPage) {
          this.queryRequest.pagedQueryInfo.index = val.page
          this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        this.handleQuery()
      }
    },
    options2: {
      handler(val) {
        if (val.itemsPerPage == -1) {
          this.queryEqpProdRequest.pagedQueryInfo.index = 1
          this.queryEqpProdRequest.pagedQueryInfo.pageSize = 999999
        } else if (!!val.page && !!val.itemsPerPage) {
          this.queryEqpProdRequest.pagedQueryInfo.index = val.page
          this.queryEqpProdRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        this.eqpInfoQuery()
      }
    },
    queryEqpProdRequest: {
      handler() {
        this.eqpInfoQuerySelected = dataChangedCount(this, 'queryEqpProdRequest')
      },
      deep: true
    }
  },
  methods: {
    workSheetPrint() {
      this.$print(this.$refs.print) // 使用
    },
    //物料信息
    showMaterInfos(item) {
      let req = {
        id: item.id,
        materialsInfo: this.queryRequest.materialsInfo
      }
      details(req).then(res => {
        this.tableMaterInfos = res.materialInfoList;
        this.showMaterFlag = true;
      }).catch(() => {
        // this.loading = false
      })
      // this.tableMaterInfos = item.materialInfoList;
    },

    extend() {
      this.seniorQueryFlag = !this.seniorQueryFlag;
    },
    resetQuery() {
      Object.assign(this.$data, this.$options.data())
    },
    resetEqpInfoQuery() {
      Object.assign(this.$data.queryEqpProdRequest, this.$options.data().queryEqpProdRequest)
      this.eqpInfoQuery()
    },
    queryPageReset() {
      this.queryRequest.pagedQueryInfo.index = 1;
      this.handleQuery();
    },

    handleQuery() {
      this.loading = true
      console.log(this.queryRequest, "queryRequest")
      queryRequest(this.queryRequest).then(res => {
        this.list = res.list
        this.total = res.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    //设备基础信息查询
    eqpInfoQuery() {
      this.eqpInfoIsSearchLoading = true
      queryEqpProdList(this.queryEqpProdRequest).then(res => {
        this.eqpInfoList = res.list
        this.eqpInfoTotal = res.total
        this.eqpInfoIsSearchLoading = false
      }).catch(() => {
        this.eqpInfoIsSearchLoading = false
      })
    },
    //入库申请单弹窗打开
    storageApplyOpen() {
      Object.assign(this.$data.storageApplyRequest, this.$options.data().storageApplyRequest)
      this.dialog = !this.dialog
      //初始化数据
      this.fileInfo = null
      this.importInfo = []
      this.failInfoList = []
      this.$nextTick(() => {
        this.$refs.dialogForm.reset()
      })
    },
    //获取模板
    getMould() {
      this.isShowLoading = true;
      materialTemplate({}).then(res => {
        this.isShowLoading = false;
        reportDownLoad(res);
      }).catch(() => {
        this.isShowLoading = false;
      });
    },
    //获取标准数据
    getBaseEqpInfo() {
      const eqpInfo = this.eqpInfoSelected.pop()
      this.storageApplyRequest.relatedEqpModel = eqpInfo.eqpModel
      this.storageApplyRequest.relatedEqpName = eqpInfo.eqpName
      this.storageApplyRequest.relatedEqpBrand = eqpInfo.eqpBrand
      this.storageApplyRequest.relatedEqpProdNo = eqpInfo.id
      this.baseEqpInfoDialog = !this.baseEqpInfoDialog
    },
    // 根据入库单类型生成入库单号
    getInboundNo() {
      if (this.storageNoType == '01') {
        getKyInboundNo().then(res => {
          this.storageApplyRequest.storageNo = res;
        }).catch(() => {

        });
        return;
      }
      if (this.storageNoType == '02') {
        getCkInboundNo().then(res => {
          this.storageApplyRequest.storageNo = res;
        }).catch(() => {
        });
        return;
      }
    },
    //跳转页面
    toJumpPage(item) {
      this.$router.push({path: '/warehouse-out-record?outboundNum=' + item.relatedOutboundNo})
      // let xtbl = this.$router.resolve({path: '/warehouse-out-record?outboundNum=' + item.relatedOutboundNo});
      // this.$store.dispatch('setCurretTitle', '出库记录');
      // window.open(xtbl.href);
    },
    // 上传文件方法
    uploadFile() {
      const formData = new window.FormData();
      //新增资产管理部门和所属部门字段
      if (!this.fileInfo) {
        return;
      } else {
        this.uploadIsLoading = true;
        formData.append('file', this.fileInfo);
        materialImport(formData).then(res => {
          this.uploadIsLoading = false;
          this.importInfo = res
          this.failInfoList = this.importInfo.failInfoList
          this.storageApplyRequest.materialsInfo = this.importInfo.materialInfo
          if (this.failInfoList.length > 0) {
            this.$refs.notify.show("文件内容有误", {timeout: 1000, color: 'red'});
          } else {
            this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
          }
        }).catch(() => {
          this.uploadIsLoading = false;
        });
      }
    },
    imgListCheck() {
      if (this.storageApplyRequest.imgFile && this.storageApplyRequest.imgFile.length > 0) {
        let imgUrlList = [];
        this.storageApplyRequest.imgFile.forEach(item => {
          imgUrlList.push(item.key)
        })
        this.storageApplyRequest.imgList = imgUrlList
      }
    },
    //入库申请
    storageApply() {
      if (this.$refs.dialogForm.validate()) {
        this.submitLoadding = true;
        this.imgListCheck();
        storageApply(this.storageApplyRequest).then(() => {
          this.dialog = false;
          this.submitLoadding = false;
          this.$refs.notify.show("申请成功", {timeout: 1000, color: 'success'});
          this.handleQuery();
        }).catch(() => {
          this.submitLoadding = false;
          this.$refs.notify.show("申请失败", {timeout: 1000, color: 'success'});
        });
      }
    },
    //办理入库页面打开
    storageHandleOpen(data) {
      let req = {
        id: data.id,
      }
      details(req).then(res => {
        // 使用 Vue.set 或 Object.assign 确保响应性
        this.storageHandleData = Object.assign({}, res);
        this.$set(this.storageHandleData, 'accInfoPicList', res.accInfoPicList || []);
        this.$set(this.storageHandleData, 'packagePicList', res.packagePicList || []);
        let index = 1;
        this.storageHandleData.materialInfoList.forEach(item => {
          item.index = index;
          index = index + 1;
        })
        this.storageHandleDialog = true;
      }).catch(() => {
        // this.loading = false
      })
    },
    //入库核验单打开
    storageReportOpen(data) {
      let req = {
        id: data.id,
      }
      details(req).then(res => {
        this.storageReportData = res;
        this.storageReportDialog = true;
        getBase64(this.storageReportData.logoPath, data => {
          this.base64LogoImg = data
        })
      }).catch(() => {
        // this.loading = false
      })
    },
    //办理入库
    storageHandle() {
      if (this.storageHandleData.requestId) {
        // 图片必传校验
        if (!this.storageHandleData.accInfoPicList || this.storageHandleData.accInfoPicList.length === 0) {
          this.$refs.notify.show("请上传至少一张备件图片", {timeout: 1000, color: 'red lighten-1'});
          return;
        }
        if (!this.storageHandleData.packagePicList || this.storageHandleData.packagePicList.length === 0) {
          this.$refs.notify.show("请上传至少一张送货包装图片", {timeout: 1000, color: 'red lighten-1'});
          return;
        }
      }
      this.storageHandleLoading = true;
      this.storageHandleRequest.aimsWarehouseId = this.storageHandleData.aimsWarehouseId;
      this.storageHandleRequest.id = this.storageHandleData.id;
      this.storageHandleRequest.packagePicList = this.storageHandleData.packagePicList
      this.storageHandleRequest.accInfoPicList = this.storageHandleData.accInfoPicList
      this.storageHandleRequest.outMaterialInfos = this.storageHandleData.outMaterialInfoList;
      let storageApplyMaterialInfos = [];
      this.storageHandleData.materialInfoList.forEach(item => {
        let flag = false;
        let storageApplyMaterialInfo = {
          materielProdNo: "",
          storageLocation: "",
          factSerialNo: "",
          businessLabel: "",
        };
        storageApplyMaterialInfo.materielProdNo = item.materielProdNo;
        if (item.storageLocation != null && item.storageLocation.length > 0) {
          storageApplyMaterialInfo.storageLocation = item.storageLocation;
          flag = true
        }
        if (item.needSerialNoFlag == true && item.factSerialNo != null && item.factSerialNo.length > 0) {
          storageApplyMaterialInfo.factSerialNo = item.factSerialNo;
          flag = true
        }
        if (item.businessLabel != null && item.businessLabel.length > 0) {
          storageApplyMaterialInfo.businessLabel = item.businessLabel;
          flag = true
        }
        if (flag) {
          storageApplyMaterialInfos.push(storageApplyMaterialInfo);
        }
      })
      console.log("storageApplyMaterialInfos")
      this.storageHandleRequest.storageApplyMaterialInfos = storageApplyMaterialInfos
      console.log("---------this.storageHandleRequest" + this.storageHandleRequest.aimsWarehouseId)
      console.log("---------this.storageHandleRequest" + this.storageHandleRequest)
      storageHandle(this.storageHandleRequest).then(() => {
        this.storageHandleDialog = false;
        this.storageHandleLoading = false;
        this.$refs.notify.show("办理成功", {timeout: 1000, color: 'success'});
        this.handleQuery();
      }).catch(() => {
        this.storageHandleLoading = false;
      });
    },
    //拒绝入库打开窗口
    storageRefuseOpen(id) {
      this.storageRefuseDialog = true
      this.storageRefuseRequest.id = id;
    },
    //拒绝入库
    storageRefuse() {
      if (this.storageRefuseRequest.refuseReason === "") {
        this.$refs.notify.show("请输入拒绝原因", {timeout: 1000, color: 'red lighten-1'});
        return;
      }
      this.storageRefuseLoading = true;
      storageRefuse(this.storageRefuseRequest).then(() => {
        this.storageHandleDialog = false;
        this.storageRefuseDialog = false;
        this.storageRefuseLoading = false;
        this.$refs.notify.show("拒绝成功", {timeout: 1000, color: 'success'});
        this.handleQuery();
      }).catch(() => {
        this.storageRefuseLoading = false;
        this.$refs.notify.show("拒绝失败", {timeout: 1000, color: 'red lighten-1'});
      });
    },
    //重新申请
    reApply(data) {
      this.fileInfo = null
      this.importInfo = []
      this.failInfoList = []
      Object.assign(this.storageApplyRequest, this.$options.data().storageApplyRequest);
      Object.assign(this.storageApplyRequest, data);
      //重新申请避免重复单号
      this.storageApplyRequest.storageNo = "";
      this.storageNoType = '';
      this.dialog = !this.dialog

    },
    //物料附件信息
    openAttachInfo(item) {
      this.uploadMaterialInfo = item;
      this.attachedInfoDialog = true;
    },
    showImg(url) {
      this.imgDialog = true;
      this.imgUrl = url;
    },
    //图片上传
    uploadImgFile() {
      if (!this.imgFile) {
        return;
      }
      const isOverSize = this.imgFile.size / 1024 / 1024 < 2;
      if (!isOverSize) {
        this.$refs.notify.show("上传文件大小不能超过2MB", {timeout: 1000, color: 'red lighten-1'});
        return;
      }
      this.uploadIsImgLoading = true;
      var formData = new window.FormData();
      formData.append('file', this.imgFile);
      ossUpload(formData).then(res => {
        this.uploadIsImgLoading = false;
        this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
        // 应该返回url
        this.storageApplyRequest.imgFile.push(res);
        this.imgFile = null;
      }).catch(err => {
        this.uploadIsImgLoading = false;
      });
    },
    uploadImgOtherFile(item) {
      if (!this.imgFile) {
        return;
      }
      const isOverSize = this.imgFile.size / 1024 / 1024 < 2;
      if (!isOverSize) {
        this.$refs.notify.show("上传文件大小不能超过2MB", {timeout: 1000, color: 'red lighten-1'});
        return;
      }
      this.uploadIsImgLoading = true;
      var formData = new window.FormData();
      formData.append('file', this.imgFile);
      ossUpload(formData).then(res => {
        this.uploadIsImgLoading = false;
        this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
        // 应该返回url
        item.push(res.url);
        this.imgFile = null;
      }).catch(err => {
        this.uploadIsImgLoading = false;
      });
    },
    //文件上传
    uploadAnnexFile() {
      if (!this.annexFileInfo) {
        return;
      }
      console.log(this.annexFileInfo, 'fileInfo9999');
      this.loading.uploadIsLoading = true;
      var formData = new window.FormData();
      formData.append('file', this.annexFileInfo);
      ossUpload(formData).then(res => {
        this.loading.uploadIsLoading = false;
        this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
        // 应该返回url
        this.uploadMaterialInfo.attachedInfo.push(res);
      }).catch(err => {
        this.loading.uploadIsLoading = false;
      });
    },
    deleteImg(index) {
      this.storageApplyRequest.imgFile.splice(index, 1);
    },
    deleteImg(item, index) {
      item.splice(index, 1);
    },
    // deleteImg(index) {
    //   this.uploadMaterialInfo.attachedInfo.splice(index, 1);
    // },
    report() {
      this.exportLoading = true;
      this.isLoading = true;
      reportExport(this.queryRequest).then(res => {
        this.$router.push({
          path: '/export-report-queue?id=' + res
        });
        // downloadReportExcel(res);
        this.isLoading = false;
        this.exportLoading = false;
      }).catch(err => {
        this.isLoading = false;
        this.exportLoading = false;
      });
    },
  },
  created() {
    const storageNo = this.$route.query.storageNo;
    if (storageNo) {
      this.queryRequest.storageNo = storageNo
    }
    const relatedOutboundNo = this.$route.query.relatedOutboundNo;
    if (relatedOutboundNo) {
      this.queryRequest.relatedOutboundNo = relatedOutboundNo
    }
    // const materielProdNo = this.$route.query.materielProdNo;
    // if (materielProdNo) {
    //   this.queryRequest.materielProdNo = materielProdNo
    // }
    // const factSerialNo = this.$route.query.factSerialNo;
    // if (factSerialNo) {
    //   this.queryRequest.factSerialNo = factSerialNo
    // }
    this.handleQuery();
  },
  mounted() {
  }
  ,
}
</script>

<style scoped>
.work-sheet-table {
  text-align: left;
  width: 100%;
  font-size: 0.9em;
}

.work-sheet {
  padding: 0px 20px;
}

.work-sheet-table tr td {
  padding: 3px;
  padding-left: 10px;
}

.work-sheet-table td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

/*.m-r-2 {*/
/*  margin-right: 4px;*/
/*}*/
/deep/ .input-center input {
  text-align: center;
}

.img-close {
  position: absolute;
  right: 0;
}
</style>
